export const workOrderPublic = {
  data() {
    return {
      showCopy: true,
      showHideList: [],
      orderTheme: {},
      orderDescribe: {},
      showCustomerInfo: false,
      contentList: {'dictDescr': '\'color\':\'#ED4014\',\'shortValue\':\'N\''},
      baseUploadUrl: this.baseURL + "common/upload.json?type=workOrderFile&companyNo=" + localStorage.getItem("companyId"),
      contentForDelete:'',
      radioForDelete:'',
      dialogForDelete:false,
      contentForPlace:'',
      isSecretForReply:true,
      contentForReply:'',
      storeForHandle:'',
      dialogVisible:false,
      showColorForSla:{},
      showSlaImgHis:'',
      historyTop:{'height':''},
      historyBottom:{'height':''},
      roleList: JSON.parse(localStorage.getItem("roleList")),
      configInfo: JSON.parse(localStorage.getItem("configInfo")),
      agentInfo: JSON.parse(localStorage.getItem("agentInfo")), //座席信息
      emojiList: require('@/assets/emotion.json'),
      hisTotal:0,
      hisPageSize:20,
      hisCurrentPage:1,
      showAddInput: {},
      pageSizeList: [10, 20, 30, 40, 50, 100, 200],
      isOrderStatePause: '1',//暂停状态是否禁用，1为不禁用，0反之
      isOrderStateDone: '-12',//处理完毕之后的状态值
      isOrderStateOpen:'',//处理中是否被禁用 1为不禁用，0反之
      showFinish:false,
      showReset:false,
      showContent:'',
      showHandlerPop:false,
      actionForHandler:'',
      fromWhere:'',
      spinShow:false,
      placeHolderForInput:'请在此输入信息("#"搜索快捷回复)',
      cancelPause:'',
      replySourceData : '',
      spinShowForDialog:false,
      loading:false,
      isOrderStateNew:'',//未分配是否被禁用 1为不禁用，0反之
      isOrderStateAssign:'',//已分配是否被禁用 1为不禁用，0反之
    }
  },
  methods: {
    clientScreenHeight:function(flag){
      let clientHeight=document.documentElement.clientHeight;
      let height = document.getElementsByClassName("rightOneTop");
      if(height && height.length > 0){
        let newHeight = 0;
        let twoHeight = 0;
        for (let i = 0;i < height.length;i++){
          twoHeight = height[i].offsetHeight;
          if(twoHeight > 0){
            break;
          }
        }
        switch (flag) {
          case 'screen':
            newHeight = clientHeight - twoHeight - 180;
            if('1' == this.wotype){
              this.rightHeightTwo.height = newHeight+'px';
            }else{
              this.historyBottom.height = newHeight+'px';
            }
            return;
            break;
          case 'online':
            newHeight = clientHeight - twoHeight - 150;
            if('1' == this.wotype){
              this.rightHeightTwo.height = newHeight+'px';
            }else{
              this.historyBottom.height = newHeight+'px';
            }
            break;
          default:
            newHeight = clientHeight - twoHeight - 100;
            break;
        }
        this.rightHeightTwo.height = newHeight+'px';
      }
    },
    auditAndReset:function(action,fromWhere){
      if(action){
        this.actionForHandler = action;
        this.fromWhere = fromWhere;
        this.showHandlerPop = true;
      }
    },
    closeHandlerPop:function(flag,fromWhere){
      this.showHandlerPop = false;
      if(flag){
        this.initWorkOrder(fromWhere);
      }
    },
    //设备信息页面显示数量改变
    hisChangeSize(event) {
      this.hisCurrentPage = 1;
      this.hisPageSize = event;
      this.getHistoryWork();
    },
    //设备信息当前页改变
    hisChangeCurrent(event) {
      this.hisCurrentPage = event;
      this.getHistoryWork();
    },
    changeFile:function(item,indexOne,index){
      if('edit' == this.addOrEdit){
        if(item){
          let customValue = item.popCustomValue;
          if(customValue){
            customValue = JSON.parse(customValue);
            let newFlag = 0;
            for (let n = 0; n < customValue.length;) {
              newFlag++;
              if (!customValue[n].downloadAddr) {
                customValue.splice(n, 1);
              } else if (!customValue[n].description) {
                this.$Message.info("第" + newFlag + "个附件已上传成功，但对应备注为空，请确认后重试");
                return false;
              } else {
                n++;
              }
            }
          }
          // if(!customValue || customValue.length < 1){
          //   return false;
          // }
          this.editWorkOrder('', item, indexOne, index, customValue,'','','');
        }
      }
    },
    initWorkOrder:function(fromWhere){
      this.addOrEdit = 'edit';
      if(!this.workOrderId || '-1' == this.workOrderId){
        this.workOrderId = '-1';
        this.addOrEdit = 'add';
      }
      let param = {
        journalType: "",
        menuId: "",
        id: this.workOrderId,
      };
      this.uploadList = [];
      let that = this;
      this.historywoList = [];
      this.historyList = [];
      this.$http.post("workOrder/toEdit.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        that.fileData = res.data.obj.groupList;
        that.orderTheme = {};
        that.orderDescribe = {};
        that.showFileList(fromWhere);
        that.contentList = {'dictDescr': {'color':'#ED4014','shortValue':'N'}};
        that.flowList = [];
        let contentList = [];
        //工单暂停状态是否被禁用
        that.isOrderStatePause = res.data.obj.isOrderStatePause;
        that.isOrderStateDone = res.data.obj.isOrderStateDone;
        that.isOrderStateOpen = res.data.obj.isOrderStateOpen;
        that.isOrderStateNew = res.data.obj.isOrderStateNew;
        that.isOrderStateAssign = res.data.obj.isOrderStateAssign;
        //暂停所需状态
        that.cancelPause = res.data.obj.prePauseState;
        if(res.data.obj.list && res.data.obj.list.length>0){
          contentList = res.data.obj.list;
          if (res.data.obj.flowList) {
            //这里将客户与座席谈话的list里面的文件地址转成JSON
            that.flowList = res.data.obj.flowList;
            for (let i = 0; i < that.flowList.length; i++) {
              if (that.flowList[i].fileAddr) {
                that.flowList[i].fileAddr = JSON.parse(that.flowList[i].fileAddr);
              }
            }
          }
          that.contentList = contentList[0];
          if (that.contentList.dictDescr) {
            //这里将自定义设置的状态颜色转成JSON
            that.contentList.dictDescr = JSON.parse(that.contentList.dictDescr);
          }
          // //sla时间格式化
          let newSlaTime = that.getSlaTime(that.contentList.isSlaTime,that.contentList.slaTime,that.contentList.dictDescr ? that.contentList.dictDescr.color ? that.contentList.dictDescr.color : '' : '');
          that.contentList.slaTime = newSlaTime.realValue;
          that.showColorForSla = newSlaTime.showColorForSla;
          that.showSlaImg = newSlaTime.showSlaImg;
        }
        if(contentList[0]){
          for (let key in contentList[0]) {
            let value = contentList[0][key];
            for (let j = 0; j < that.fileData.length; j++) {
              let allColumnInfo = that.fileData[j].allColumnInfo;
              let phoneIsHide = that.configInfo.phoneIsHide;
              for (let i = 0; i < allColumnInfo.length; i++) {
                  let customColName = allColumnInfo[i].customColName;
                  let type = allColumnInfo[i].type;
                  
                  if (customColName == key && customColName != "employeeName") {

                    // 工单系统字段禁用处理
                    if(customColName != 'orderHandler' && customColName != 'copyEmpId' && allColumnInfo[i].customIsSystem == '1' && (type == 'select' || type == 'radio' || type == 'checkbox')){
                    
                        if(allColumnInfo[i].list){
                          allColumnInfo[i].list = allColumnInfo[i].list.filter(option => option.isClose != '0' || contentList[0][key+'Id'] == option.id);
                        }
                    }

                    that.fileData[j].allColumnInfo[i].popCustomValue = value;
                    that.fileData[j].allColumnInfo[i].oldValue = value;
                    if (customColName == 'customerName') {
                      continue;
                    }
                    if (type == 'checkbox' || type == 'radio' || type == 'select' || type == 'cascade') {
                      that.fileData[j].allColumnInfo[i].popCustomValue = contentList[0][key + "Id"];
                      that.fileData[j].allColumnInfo[i].oldValue = contentList[0][key + "Id"];
                    }
                    if (customColName == 'orderHandler') {
                      let paramForHandler = {
                        id: allColumnInfo[i].id,
                        list: allColumnInfo[i].list,
                        preValue: contentList[0]["orderHandler"],
                      };
                      that.handlerList = paramForHandler;
                    }
                    if (phoneIsHide == '1' && customColName.indexOf("customerPhone") != -1) {
                      that.oldTelHide = contentList[0][key + 'Hide'];
                      that.oldTelFull = value;
                      that.fileData[j].allColumnInfo[i].popCustomValue = contentList[0][key + 'Hide'];
                      that.fileData[j].allColumnInfo[i].oldValue = contentList[0][key + 'Hide'];
                      continue;
                    }
                    if (customColName == 'orderTheme') {
                      let length = 0;
                      let html = document.createElement('span');
                      html.innerText = value;
                      html.className = 'getTextWidth';
                      document.querySelector('body').appendChild(html);
                      length = document.querySelector('.getTextWidth').offsetWidth;
                      document.querySelector('.getTextWidth').remove();
                      if (length < 20) {
                        length = 20;
                      }
                      let width = length * 2 + "px";
                      if(200 < length * 2){
                        width = "300px";
                      }
                      that.inputWidth.width = width;
                      continue;
                    }
                  }
                }
            }
            if (key == 'orderStateId') {
              // that.rightHeight.height = '40%';
              // that.rightHeightTwo.height = '59%';
              that.showInputAndButton=true;
              that.workOrderState = value;
              let roleValue = that.orderFromWhere;
              let newList = [];
              if(that.contentList.checkButton){
                newList = that.contentList.checkButton.split(',');
              }
              that.sceneList = [];
              that.selectScene = '';
              that.editHandle = true;
              that.editTable = true;
              that.editCopyId = true;
              if(that.roleList[roleValue+'1'] || !roleValue){
                that.editTable = false;
              }
              if(that.roleList[roleValue+'6'] || !roleValue){
                that.editHandle = false;
              }
              if(that.roleList[roleValue+'7'] || !roleValue){
                that.editCopyId = false;
              }
              let isNull = '';
              that.showFinish = false;
              that.showReset = false;
              that.showContent = '';
              that.placeHolderForInput = '请在此输入信息("#"搜索快捷回复)';
              //未分配、已分配、处理中、暂停、已完成、已关闭、已删除
              switch (value) {
                case '-16':
                  if(newList.indexOf(that.agentInfo.employeeId) != -1 && '1' == that.isOrderStateOpen  && (that.roleList[roleValue+'2'] || !roleValue)){
                    that.selectScene='抢单';
                    that.placeHolderForInput = '请在此输入信息("#"搜索快捷回复)，未输入内容直接抢单将默认回复：我来抢单';
                    if(that.roleList[roleValue+'2'] || !roleValue){
                      that.sceneList.push({value: '1',label: '仅回复'});
                    }
                  }else if(that.roleList[roleValue+'2'] || !roleValue){
                    that.selectScene='回复';
                  }
                  if('抢单' == that.selectScene && (that.roleList[roleValue+'3'] || !roleValue)){
                    that.sceneList.push({value: '2',label: '抢单并置为暂停'});
                  }
                  if('抢单' == that.selectScene && (that.roleList[roleValue+'4'] || !roleValue)){
                    that.sceneList.push({value: '3',label: '抢单并处理完毕'});
                  }
                  break
                case '-15':
                  if(newList.indexOf(that.agentInfo.employeeId) != -1 && '1' == that.isOrderStateOpen && (that.roleList[roleValue+'2'] || !roleValue)){
                    that.selectScene='接单';
                    that.placeHolderForInput = '请在此输入信息("#"搜索快捷回复)，未输入内容直接接单将默认回复：确认接单';
                    if(that.roleList[roleValue+'2'] || !roleValue){
                      that.sceneList.push({value: '1',label: '仅回复'});
                    }
                  }else if(that.roleList[roleValue+'2'] || !roleValue){
                    that.selectScene='回复';
                  }
                  if('接单' == that.selectScene && (that.roleList[roleValue+'3'] || !roleValue)){
                    if('1' == that.isOrderStatePause){
                      that.sceneList.push({value: '2',label: '接单并置为暂停'});
                    }
                  }
                  if('接单' == that.selectScene && (that.roleList[roleValue+'4'] || !roleValue)){
                    that.sceneList.push({value: '3',label: '接单并处理完毕'});
                  }
                  break
                case '-14':
                  if(that.roleList[roleValue+'2'] || !roleValue){
                    that.selectScene='回复';
                  }
                  if((that.selectScene && that.roleList[roleValue+'3']) || !roleValue){
                    if('1' == that.isOrderStatePause){
                      that.sceneList.push({value: '7',label: '暂停处理'});
                    }
                  }
                  if((that.selectScene && that.roleList[roleValue+'4']) || !roleValue){
                    that.sceneList.push({value: '8',label: '处理完毕'});
                  }
                  break
                case '-13':
                  if(that.roleList[roleValue+'2'] || !roleValue){
                    let newValue =that.cancelPause ? that.cancelPause.split("_") : [];
                    if(!newValue || newValue.length <= 1){
                      that.selectScene='回复';
                    }else{
                      that.selectScene='取消暂停';
                      that.sceneList.push({value: '1',label: '仅回复'});
                    }
                  }
                  if(that.selectScene && that.roleList[roleValue+'4'] || !roleValue){
                    that.sceneList.push({value: '8',label: '处理完毕'});
                  }
                  break
                case '-12' :
                  isNull = '1';
                  that.showContent = '工单处理完毕于';
                  that.showInputAndButton=false;
                  // that.rightHeight.height = '28%';
                  // that.rightHeightTwo.height = '71%';
                  if(that.roleList[roleValue+'5'] || !roleValue){
                    that.showFinish = true;
                  }
                  if(that.roleList[roleValue+'8'] || !roleValue){
                    that.showReset = true;
                  }
                  that.editHandle = true;
                  that.editCopyId = true;
                  break
                case '-11': case '-10':
                  isNull = '1';
                  that.showContent = '工单关闭于';
                  if('-10' == value){
                    that.showContent = '工单删除于';
                  }
                  that.showInputAndButton=false;
                  // that.rightHeight.height = '29%';
                  // that.rightHeightTwo.height = '70%';
                  that.editHandle = true;
                  that.editTable = true;
                  that.editCopyId = true;
                  break
                default:
                  if(that.roleList[roleValue+'2'] || !roleValue){
                    that.selectScene='回复';
                  }
                  break
              }
              if(!that.selectScene && '1' != isNull){
                that.showInputAndButton=false;
                // that.rightHeight.height = '17%';
                // that.rightHeightTwo.height = '82%';
                that.sceneList = [];
              }
              that.$forceUpdate();
            }
            if (key == 'customerId') {
                that.customerId = value;
            }
          }
        }else{
          that.fileData.forEach(item => {
            item.allColumnInfo.forEach(groupItem => {
              if(groupItem.customColName != 'orderHandler' && groupItem.customColName != 'copyEmpId' && groupItem.customIsSystem == '1' && (groupItem.type == 'select' || groupItem.type == 'radio' || groupItem.type == 'checkbox')){
                
                if(groupItem.list){
                  groupItem.list = groupItem.list.filter(option => option.isClose != '0');
                }
                if(groupItem.customColName == 'orderChannel'){
                  if(!groupItem.list.find(item => item.id == groupItem.customValue)){  
                    groupItem.customValue = "";
                    groupItem.popCustomValue = "";
                  }
                }
                
              }
            })
          })
        }
        if('telephoneScreen' == fromWhere){
          if ('1' == that.configInfo.isHiddenService) {
            that.showColumnList["serviceList"] = [];
            that.showColumnList["serviceRule"] = {};
          }
          that.showColumnList["screenAiContent"] = that.screenAiContent;
          that.showColumnList["workOrderList"] = that.fileData;
          that.showColumnList["agentUUid"] = that.callUuid;
          that.showColumnList["workOrderId"] = that.workOrderId;
          that.showColumnList["uploadList"] = that.uploadList;
          that.showColumnList["orderDescribe"] = that.orderDescribe;
          that.showColumnList["orderTheme"] = that.orderTheme;
          that.showColumnList["historyList"] = that.historyList;
          that.showColumnList["historywoList"] = that.historywoList;
          that.showColumnList["tabsName"] = that.tabsName;
          that.showColumnList["wotype"] = that.wotype;
          that.showColumnList["pstnNumber"] = that.pstnNumber;
          that.showColumnList["showAddInput"] = that.showAddInput;
          that.screenColumn = that.showColumnList;
          // 担心有个指针问题，会把已有的数据赋值成新的数据
          that.showColumnList.showForm = true;
          that.$store.commit('addCustomerData', that.showColumnList);
          that.showForm = true;
          if ('1' == that.configInfo.isHiddenService) {
            that.tabName = 'name3';
            that.clickChangeTabs(that.tabName);
          }
        }else if('allWorkOrder' == fromWhere){
          if('edit' == that.addOrEdit){
            that.pageUuId = 'b_w_1-' + that.workOrderId;
            let param = {
              fileData: that.fileData,
              contentList: that.contentList,
              flowList: that.flowList,
              uploadList: that.uploadList,
              pageUuId: that.pageUuId,
              orderTheme: that.orderTheme,
              orderDescribe: that.orderDescribe,
              isSecret: that.isSecret,
              showPreInput: that.showPreInput,
              workId: that.workOrderId,
            };
            that.$store.commit('addWorkOrderData', param);
            let name = that.orderTheme.popCustomValue;
            if(name){
              name = name.replace(/<[^>]+>/g, "");
              if (name && name.length > 5) {
                name = name.substring(0, 5) + "…";
              }
              that.$emit("updateWorkOrderTabName", name, that.workOrderId, that.addWorkOrderFlag.split(",")[0]);
            }
          }
        }else if('onlineInfo' == fromWhere){
          let showColumnList = {
            fileData: that.fileData,
            contentList: that.contentList,
            flowList: that.flowList,
            uploadList: that.uploadList,
            pageUuId: that.pageUuId,
            orderTheme: that.orderTheme,
            orderDescribe: that.orderDescribe,
            isSecret: that.isSecret,
            showAddInput: that.showAddInput,
            workId: that.workOrderId,
            openId:that.openId,
          };
          let newParam = JSON.parse(JSON.stringify(showColumnList));
          that.$store.commit('pushOnlineWorkOrderInfo',newParam);
          that.onlineInfo = that.$store.getters.getOnlineInfoByOpenId(that.openId);
          if(that.onlineInfo){
            let workOrderInfo = that.onlineInfo.workOrderInfo;
            if(workOrderInfo){
              that.fileData = workOrderInfo.fileData;
              that.contentList = workOrderInfo.contentList;
              that.flowList = workOrderInfo.flowList;
              that.uploadList = workOrderInfo.uploadList;
              that.pageUuId = workOrderInfo.pageUuId;
              that.orderTheme = workOrderInfo.orderTheme;
              that.orderDescribe = workOrderInfo.orderDescribe;
              that.isSecret = workOrderInfo.isSecret;
              that.showAddInput = workOrderInfo.showAddInput;
            }
          }
          that.$forceUpdate();
        }
      });
    },
    //拆分sla时间
    getSlaTime:function(isSlaTime,value,color){
      let param = {showColorForSla:'', showSlaImg:'', realValue:'',};
      switch (isSlaTime) {
        case '1':
          param.showColorForSla = {'color':'#00CC33'};
          param.realValue = ' <span style="color: #9ea19f">剩余&nbsp;</span>';
          param.showSlaImg = '2';
          if(value && value.indexOf('-') != -1){
            param.realValue = ' <span style="color: #9ea19f">超时&nbsp;</span>';
            param.showColorForSla = {'color':'red'};
            param.showSlaImg = '1';
            value = value.split('-')[1];
          }
          let hourLength = value.indexOf('小时');
          let minLength = value.indexOf('分钟');
          let hour = value.substring(0,hourLength);
          let newHour = 0;
          if(hour){
            newHour = hourLength+2;
          }
          let min = '';
          if(minLength && minLength>0){
            min = value.substring(newHour,minLength);
          }
          if(hour){
            param.realValue = param.realValue+hour+'<span style="color: #9ea19f">小时</span>';
          }
          if(min){
            param.realValue = param.realValue+min+'<span style="color: #9ea19f">分钟</span>';
          }
          break
        case '0':
          param.showColorForSla = '';
          if(color){
            param.showColorForSla = {'color':color};
          }
          param.showSlaImg = '0';
          param.realValue = value;
          break
        case '-1':
          let newValue = '<span style="color: #9ea19f">响应时长&nbsp;&nbsp;</span>';
          let array = value.split(",");
          for (let i=0;i<array.length;i++){
            if(array[i]){
              if(i == 1){
                newValue = newValue+ '<span style="color: #9ea19f">处理时长&nbsp;&nbsp;</span>  ';
              }
              if('-1' == array[i]){
                newValue = newValue+ '<span style="color: #9ea19f">  不足一分钟&nbsp;&nbsp;</span>  ';
                continue;
              }
              param.showColorForSla = {'color':'#00CC33'};
              if(array[i].indexOf('-') != -1){
                param.showColorForSla = {'color':'red'};
                array[i] = array[i].split('-')[1];
              }
              let hourLength = array[i].indexOf('小时');
              let minLength = array[i].indexOf('分钟');
              let hour = array[i].substring(0,hourLength);
              let newHour = 0;
              if(hour){
                newHour = hourLength+2;
              }
              let min = '';
              if(minLength && minLength>0){
                min = array[i].substring(newHour,minLength);
              }
              if(hour){
                newValue = newValue+hour+'<span style="color: #9ea19f">小时&nbsp;</span>';
              }
              if(min){
                newValue = newValue+min+'<span style="color: #9ea19f">分钟&nbsp;&nbsp;</span>';
              }
            }
          }
          param.realValue = newValue;
          param.showSlaImg = '0';
          break
      }
      return param;
    },
    //历史工单展示私密动作
    showImgForHistory: function (action, index, indexFlow) {
      if ('1' == action) {
        this.historywoList[index].flowList[indexFlow].showImg = true;
      } else {
        this.historywoList[index].flowList[indexFlow].showImg = false;
      }
      this.$forceUpdate();
    },
    //展示私密动作
    showImg: function (action, item, index, fromWhere) {
      if(this.$refs.editDiv){
        this.showInput('2',fromWhere);
      }
      if ('1' == action) {
        this.flowList[index].showImg = true;
      } else {
        this.flowList[index].showImg = false;
      }
      this.$forceUpdate();
    },
    //隐藏或展示分组
    showOrHideGroup: function (index) {
      if ('0' == this.showHideList[index]) {
        this.showHideList[index] = '1';
      } else {
        this.showHideList[index] = '0';
      }
      this.$forceUpdate();
    },
    //确定修改处理人
    saveChange:function(flag){
      if(!this.storeForHandle){
        return false;
      }
      let value = this.storeForHandle.split('$^');
      let event = value[0];
      let item = value[1];
      item = JSON.parse(item);
      let indexOne = value[2];
      let index = value[3];
      if(!this.contentForReply){
        this.contentForReply = this.contentForPlace.split('：')[1];
      }
      this.spinShowForDialog = true;
      this.editWorkOrder(event,item,indexOne,index,'',this.contentForReply,this.isSecretForReply,flag);
    },
    //取消修改处理人
    cancelChange:function(){
      if(!this.storeForHandle){
        return false;
      }
      let value = this.storeForHandle.split('$^');
      let indexOne = value[2];
      let index = value[3];
      let newOld = "";
        if(this.fileData[indexOne].allColumnInfo[index].oldValue){
          newOld = this.fileData[indexOne].allColumnInfo[index].oldValue;
        }
        this.$set(this.fileData[indexOne].allColumnInfo[index],'popCustomValue',newOld);
        this.$forceUpdate();
        this.dialogVisible = false;
        return false;
    },
    //处理人修改弹窗
    editOrderHandler:function(event, item, indexOne, index){
      if("add" == this.addOrEdit){
        for (let i=0;i<this.fileData.length;i++){
            let allColumnIno = this.fileData[i].allColumnInfo;
            for (let k=0;k<allColumnIno.length;k++){
              if ('orderState' == allColumnIno[k].customColName) {
                if(this.fileData[i].allColumnInfo[k].list && this.fileData[i].allColumnInfo[k].list.length > 0){
                  let newLength = this.fileData[i].allColumnInfo[k].list;
                  for (let g=newLength.length-1;g>=0;g--){
                    let newOne = newLength[g].id;
                    if('-12' === newOne || '-16' === newOne || '-15' === newOne || '-14' === newOne){
                      this.fileData[i].allColumnInfo[k].list.splice(g,1);
                    }
                  }
                }
                if(event == this.agentInfo.employeeId){
                  let paramArr = [
                    {
                      dictValue : "已完成",
                      dictCode : "75",
                      id : "-12"
                    },{
                      dictValue : "处理中",
                      dictCode : "75",
                      id : "-14"
                    }
                  ];
                  if(!this.fileData[i].allColumnInfo[k].list){
                    this.fileData[i].allColumnInfo[k].list = [];
                  }
                  if('-12' != this.isOrderStateDone){
                    paramArr.splice(0,1);
                  }
                  this.fileData[i].allColumnInfo[k].popCustomValue = '-14';
                  if('1' != this.isOrderStateOpen){
                    let length = paramArr.length == 1 ? 0 : 1;
                    paramArr.splice(length,1);
                    this.fileData[i].allColumnInfo[k].popCustomValue = '';
                  }
                  this.fileData[i].allColumnInfo[k].list = this.fileData[i].allColumnInfo[k].list.concat(paramArr);
                }else{
                  if(!this.fileData[i].allColumnInfo[k].list){
                    this.fileData[i].allColumnInfo[k].list = [];
                  }
                  let param = {};
                  if(event.indexOf('_') != -1 && '1' == this.isOrderStateNew){
                    param = {
                      dictValue : "未分配",
                      dictCode : "75",
                      id : "-16"
                    };
                    this.fileData[i].allColumnInfo[k].list.push(param);
                    //选择了服务组。此时状态应为未分配
                    this.fileData[i].allColumnInfo[k].popCustomValue = '-16';
                  }else if('1' === this.isOrderStateAssign){
                    param = {
                      dictValue : "已分配",
                      dictCode : "75",
                      id : "-15"
                    };
                    this.fileData[i].allColumnInfo[k].list.push(param);
                    this.fileData[i].allColumnInfo[k].popCustomValue = '-15';
                  }
                }
                this.$forceUpdate();
                return false;
              }
            }
        }
      }
      if("edit" != this.addOrEdit || event == this.fileData[indexOne].allColumnInfo[index].oldValue){
        return false;
      }
      this.isSecretForReply = true;
      this.contentForReply = '';
      this.storeForHandle = '';
      let customPreShowValue = '';
      if(event && event.indexOf('g_') !== -1){
        let itemForOld = item.list[0].serviceGroup.find(items => {
          return items.id == event;
        });
        if (itemForOld && itemForOld.dictValue) {
          customPreShowValue = itemForOld.dictValue;
        }
      }else{
        let itemForOld = item.list[0].employeeGroup.find(items => {
          return items.id == event;
        });
        if (itemForOld && itemForOld.dictValue) {
          customPreShowValue = itemForOld.dictValue;
        }
      }
      this.contentForPlace = '请在此输入信息，未输入内容直接提交回复，将默认回复：工单交由'+customPreShowValue;
      this.dialogVisible = true;
      this.storeForHandle = event+"$^"+JSON.stringify(item)+"$^"+indexOne+"$^"+index;
    },
    //新建工单时修改工单状态再次搜索扩展字段
    searchForAdd:function(type,fromWhere){
      if(!type){
        return false;
      }
      let param = {
        journalType: "",
        menuId: "",
        id: '-1',
        orderType:type,
      };
      let that = this;
      this.$http.post("workOrder/toEdit.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        let newFileData = res.data.obj.groupList;
        for (let j = 0; j < newFileData.length; j++) {
          let allColumnInfo = newFileData[j].fieldList;
          for (let i = 0; i < allColumnInfo.length; i++) {
            let customColName = allColumnInfo[i].customColName;
            let item = that.fileData[j].allColumnInfo.find(item => item.customColName === customColName);
            if('orderState' == customColName){
              newFileData[j].fieldList[i].list = item.list;
            }
            if(item && item.popCustomValue){
              newFileData[j].fieldList[i].popCustomValue = item.popCustomValue;
            }
          }
        }
        that.fileData = newFileData;
        that.showFileList(fromWhere);
      });
    },
    //编辑保存字段
    editWorkOrder: function (event, item, indexOne, index, customerName,replyValue,replySecret,fromWhere) {
      if ("add" == this.addOrEdit && "orderType" == item.customColName) {
        this.searchForAdd(event,fromWhere);
        return false;
      }
      if (("edit" != this.addOrEdit || "customerPhone" == item.customColName) && '-1' != item.id) {
        return false;
      }
      if ("customerName" == item.customColName) {
        item.type = "text";
      }
      let customPreShowValue = "";
      let customAfterShowValue = "";
      let customValue = "";
      let flag = false;
      if(item.customColName == 'orderHandler'){
        flag = true;
        if(item.oldValue && item.oldValue.indexOf('g_') != -1){
          let itemForOld = item.list[0].serviceGroup.find(items => {
            return items.id == item.oldValue;
          });
          if (itemForOld && itemForOld.dictValue) {
            customPreShowValue = itemForOld.dictValue;
          }
        }else{
          let itemForOld = item.list[0].employeeGroup.find(items => {
            return items.id == item.oldValue;
          });
          if (itemForOld && itemForOld.dictValue) {
            customPreShowValue = itemForOld.dictValue;
          }
        }

        if(event && event.indexOf('g_') != -1){
          let itemForNew = item.list[0].serviceGroup.find(items => {
            return items.id == event;
          });
          if (itemForNew && itemForNew.dictValue) {
            customAfterShowValue = itemForNew.dictValue;
          }
        }else{
          let itemForNew = item.list[0].employeeGroup.find(items => {
            return items.id == event;
          });
          if (itemForNew && itemForNew.dictValue) {
            customAfterShowValue = itemForNew.dictValue;
          }
        }

        if (event) {
          customValue = event;
        }
      }else if("cascade" == item.type || item.customColName == 'copyEmpId'){
        customAfterShowValue = "更新"+item.customName+"数据";
        let oldValueString = "";
        if(item.oldValue && item.oldValue.length>0){
          oldValueString = item.oldValue.toString();
        }
        let newValueString = "";
        if(event && event.length>0){
          newValueString = event.toString();
        }
        if(newValueString == oldValueString){
          return false;
        }
        event = this.arrayDeDuplication(event);
        if (event) {
          customValue = event.toString();
        }
      }else if ("select" == item.type || "radio" == item.type || "cascade" == item.type) {
        flag = true;
        let itemForOld = item.list.find(items => {
          return items.id == item.oldValue;
        });
        if (itemForOld && itemForOld.dictValue) {
          customPreShowValue = itemForOld.dictValue;
        }

        let itemForNew = item.list.find(items => {
          return items.id == event;
        });
        if (itemForNew && itemForNew.dictValue) {
          customAfterShowValue = itemForNew.dictValue;
        }
        if(customPreShowValue == customAfterShowValue){
          return false;
        }
        if (event) {
          customValue = event;
        }
      }else if("checkbox" == item.type){
        flag = true;
        let oldValueString = "";
        if(item.oldValue && item.oldValue.length>0){
          let itemForNew = "";
          oldValueString = item.oldValue.toString();
          for (let k=0;k<item.oldValue.length;k++){
            itemForNew = item.list.find(items => {
              return items.id == event[k];
            });
            if (itemForNew && itemForNew.dictValue) {
              customPreShowValue += itemForNew.dictValue+",";
            }
          }
        }
        let newValueString = "";
        if(event && event.length>0){
          let itemForNew = "";
          newValueString = event.toString();
          for (let k=0;k<event.length;k++){
            itemForNew = item.list.find(items => {
              return items.id == event[k];
            });
            if (itemForNew && itemForNew.dictValue) {
              customAfterShowValue += itemForNew.dictValue+",";
            }
          }
        }
        if(newValueString == oldValueString){
          return false;
        }
        //去除最后一位逗号
        if(customPreShowValue){
          customPreShowValue = customPreShowValue.substring(0,customPreShowValue.length-1);
        }
        if(customAfterShowValue){
          customAfterShowValue = customAfterShowValue.substring(0,customAfterShowValue.length-1);
        }
        if (event) {
          customValue = event.toString();
        }
      } else if (item.customColName == 'customerName') {
        //客户姓名由手动触发
        customValue = event;
        customAfterShowValue = customerName;
        customPreShowValue = item.oldValue;
      } else if ("datetime" == item.type) {
        //文本框
        if (item.oldValue == event) {
          return false;
        }
        customAfterShowValue = event;
        customValue = event;
      } else if("file" == item.type){
        customAfterShowValue = "更新"+item.customName+"数据";
        customValue = JSON.stringify(customerName);
        if (item.oldValue == customValue || !customerName) {
          return false;
        }
      }else{
        //文本框
        if (item.oldValue == event.target.value) {
          return false;
        }
        customAfterShowValue = event.target.value;
        customValue = event.target.value;
      }
      let journalValue = this.getFromWhereForParam(fromWhere);
      let journalType = journalValue+"=>工单编辑=>" + item.customName;
      if('-1' == item.id){
        //从在线客服而来，无法获取详情客户信息
        journalType = "在线客服=>工单信息=>更改客户";
      }
      let param = {
        journalType: journalType,
        menuId: "b_2-5-1",
        orderId: this.workOrderId,
        id: item.id,
        customType: item.type,
        customValue: customValue,
        customPreShowValue: customPreShowValue,
        customAfterShowValue: customAfterShowValue,
      };
      let that = this;
      this.$http.post("workOrder/doEditSave.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.spinShowForDialog = false;
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        if (!flag && item.customColName != 'orderTheme' && indexOne) {
          that.fileData[indexOne].allColumnInfo[index].oldValue = customValue;
        }
        if (item.customColName == 'orderTheme') {
          that.orderTheme.oldValue = customValue;
          customValue = customValue.replace(/<[^>]+>/g, "");
          if (customValue && customValue.length > 5) {
            customValue = customValue.substring(0, 5) + "…";
          }
          that.$emit("updateWorkOrderTabName", customValue, that.workOrderId, that.addWorkOrderFlag.split(",")[0]);
        }
        if(replyValue){
          that.doSendReplyInfo(replyValue,replySecret,'',fromWhere);
        }else{
          if('-1' != item.id){
            that.$Message.info("操作成功");
          }
          that.initWorkOrder(fromWhere);
        }
      });
    },
    //抄送给我，以我的名义的动作
    // handleOpen: function (action) {
    //   for (let j = 0; j < this.fileData.length; j++) {
    //     for (let i = 0; i < this.fileData[j].allColumnInfo.length; i++) {
    //       let customColName = this.fileData[j].allColumnInfo[i].customColName;
    //       // if ('1' == action) {
    //       //   //以我的名义
    //       //   if (customColName == "customerName") {
    //       //     this.fileData[j].allColumnInfo[i].popCustomValue = this.agentInfo.employeeName;
    //       //   }
    //       //   if (customColName == "customerPhone") {
    //       //     this.fileData[j].allColumnInfo[i].popCustomValue = this.agentInfo.employeeMobile;
    //       //     this.oldTelHide = this.agentInfo.employeeMobile;
    //       //     this.oldTelFull = this.agentInfo.employeeMobile;
    //       //   }
    //       //   this.customerId = '-1';
    //       // } else
    //       if ('2' == action) {
    //         //抄送给我
    //         if (customColName == "copyEmpId") {
    //           if (!this.fileData[j].allColumnInfo[i].popCustomValue) {
    //             this.fileData[j].allColumnInfo[i].popCustomValue = [];
    //           }
    //           this.fileData[j].allColumnInfo[i].popCustomValue.push(this.agentInfo.employeeId);
    //           this.fileData[j].allColumnInfo[i].popCustomValue = this.arrayDeDuplication(this.fileData[j].allColumnInfo[i].popCustomValue);
    //           this.showCopy = false;
    //         }
    //       } else {
    //         //移出我
    //         if (customColName == "copyEmpId") {
    //           this.fileData[j].allColumnInfo[i].popCustomValue.splice(this.fileData[j].allColumnInfo[i].popCustomValue.indexOf(this.agentInfo.employeeId), 1);
    //           this.fileData[j].allColumnInfo[i].popCustomValue = this.arrayDeDuplication(this.fileData[j].allColumnInfo[i].popCustomValue);
    //         }
    //         this.showCopy = true;
    //       }
    //     }
    //   }
    //   this.$forceUpdate();
    // },
    replaceMsg: function (msgContent) {
      if (msgContent.indexOf('/:') > -1) {
        for (let i = 0; i < this.emojiList.length; i++) {
          for (let n = 0; n < this.emojiList[i].length; n++) {
            let newChar = this.htmlToString(this.emojiList[i][n].chars);
            msgContent = msgContent.replace(new RegExp(RegExp.escape(newChar), 'g'), "<img src='" + this.emojiList[i][n].emoji + "'/>");
          }
        }
      }
      return msgContent;
      RegExp.escape = function (s) {
        return s.replace(/[-\/:\\^$*+?.()|[\]{}><@&]/g, '\\$&');
      };
    },
    htmlToString: function (sHtml) {
      return sHtml.replace(/[<>&"]/g, function (c) {
        return {'<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;'}[c];
      });
    },
    setStyleColor(rate) {
      if (!rate) {
        return '';
      }
      let newValue = rate
      if(newValue.indexOf(",") != -1){
        newValue = JSON.parse(newValue);
        newValue = newValue.color;
      }
      return "background:" + newValue + "";
    },
    setFontColor(rate) {
      if (!rate) {
        return '';
      }
      let newValue = rate
      if(newValue.indexOf(",") != -1){
        newValue = JSON.parse(newValue);
        newValue = newValue.color;
      }
      return "color:" + newValue + "";
    },
    getShortValue(rate){
      if (!rate) {
        return '';
      }
      let newValue = rate
      if(newValue.indexOf(",") != -1){
        newValue = JSON.parse(newValue);
        newValue = newValue.shortValue;
      }
      return newValue;
    },
    //用于发送流转信息
    doSendReplyInfo(newStr,isSecret,historyOrderId,fromWhere){
      let uploadList = "";
      if (this.uploadList && this.uploadList.length > 0) {
        uploadList = JSON.stringify(this.uploadList);
      }
      newStr = newStr.replace(/&nbsp;/ig, "");
      if(!newStr){
        this.spinShow = false;
        this.$Message.info("请输入流转信息");
        return false;
      }
      let newSecret = this.isSecret ? "1" : "0";
      if(isSecret){
        //专门为修改处理人的私密处理
        newSecret = newSecret ? "1" : "0";
      }
      let workId = this.workOrderId;
      if(historyOrderId){
        //历史记录过来的工单id
        workId = historyOrderId;
      }
      let journalValue = this.getFromWhereForParam(fromWhere)+'=>工单流转信息回复';
      let param = {
        orderId: workId,
        isSecret: newSecret,
        content: newStr,
        fileAddr: uploadList,
        journalType:journalValue,
        menuId:"null"
      };
      let that = this;
      this.$http.post("workOrder/doReply.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.spinShowForDialog = false;
          that.spinShow = false;
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        that.spinShowForDialog = false;
        that.spinShow = false;
        if(historyOrderId){
          that.getHistoryWork();
        }else{
          if(that.$refs.editDiv){
            that.$refs.editDiv.innerHTML = "";
          }
          that.showPreInput = "";
          if('allWorkOrder' != fromWhere){
            that.showAddInput = {};
          }
          that.dialogVisible = false;
          that.initWorkOrder(fromWhere);
          return;
        }
        if(isSecret){
          that.initWorkOrder(fromWhere);
        }
      });
    },
    //获取历史工单
    getHistoryWork:function(){
      let param = {
        pageNum: this.hisCurrentPage,
        pageSize: this.hisPageSize,
        journalType: "",
        menuId: "",
        customerId: this.customerId ? this.customerId : '-1',
      };
      this.uploadList = [];
      let that = this;
      this.$http.post("workOrder/toHistory.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        that.historyList = [];
        if(res.data.obj.list.content){
          that.historyList = res.data.obj.list.content;
          that.hisTotal = res.data.obj.list.totalSize;
        }
        if(that.historyList && that.historyList.length > 0 && that.currentIndex < that.historyList.length && 0 <= that.currentIndex){
          that.liClick(that.historyList[that.currentIndex],that.currentIndex);
        }
      });
    },
    //仅用于更改工单状态
    onlyChangeState:function(customId,customValue,replyValue,replySecret,fromWhere){
      let journalValue = this.getFromWhereForParam(fromWhere)+'=>工单编辑=>工单状态';
      let param = {
        journalType: journalValue,
        menuId: "b_2-5-1",
        orderId: this.workOrderId,
        id: this.dictOrderStateId,
        customType: 'select',
        customValue: customId,
        customPreShowValue: customValue.indexOf("_") != -1 ? "未分配":"",
        customAfterShowValue: customValue.split("_")[0],
      };
      this.spinShow = true;
      let that = this;
      this.$http.post("workOrder/doEditSave.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.spinShow = false;
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        that.$Message.info("操作成功");
        if(replyValue){
          that.doSendReplyInfo(replyValue,replySecret,'',fromWhere);
        }else{
          that.spinShow = false;
          that.initWorkOrder(fromWhere);
        }
      });
    },
    //抢单修改处理人，这块逻辑与别处不同，单独处理,需要重新调用修改工单状态用于流转信息提示
    grabbingOrder:function(customId,customValue,replyValue,fromWhere){
      let journalValue = this.getFromWhereForParam(fromWhere)+"=>工单编辑=>修改处理人";
      let empList = this.handlerList.list[0].employeeGroup;
      let empId = this.agentInfo.employeeId;
      let itemForEmp = empList.find(items => {
        return items.id == empId;
      });
      this.spinShow = true;
      let param = {
        journalType: journalValue,
        menuId: "b_2-5-1",
        orderId: this.workOrderId,
        id: this.handlerList.id,
        customType: 'select',
        customValue: empId,
        customPreShowValue: this.handlerList.preValue,
        customAfterShowValue: itemForEmp.dictValue,
      };
      let that = this;
      this.$http.post("workOrder/doEditSave.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.spinShow = false;
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
        that.onlyChangeState(customId,customValue,replyValue,'',fromWhere);
      });
    },
    //历史工单回复事件
    dropClickHis:function(action,index,fromWhere){
      let newHtml = this.$refs.editDivHistory[0].innerHTML;
      let str = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
        .replace(/<\/?.+?\/?>/g, ''); //替换html标签
      let newStr = str.replace(/[ ]|[\r\n]/g, "").replace(/&nbsp;/g,"");
      if(!newStr){
        this.$Message.info("请输入流转信息");
        return false;
      }
      this.doSendReplyInfo(newStr,'',this.historywoList[0].staffId,fromWhere);
      this.$refs.editDivHistory[0].innerHTML = '';
      let that = this;
      setTimeout(function () {
        that.liClick(that.historyList[that.currentIndex],that.currentIndex);
      },1000);
    },
    //菜单点击事件
    dropClick(action,fromWhere) {
      let newHtml = this.$refs.editDiv.innerHTML;
      let str = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
        .replace(/<\/?.+?\/?>/g, ''); //替换html标签
      let newStr = str.replace(/[ ]|[\r\n]/g, "");
      newStr = newStr.replace(/&nbsp;/g,"");
      if(!newStr){
        if('接单' == action){
          newStr = '确认接单';
        }else if('抢单' == action){
          newStr = '我来抢单';
        }else{
          this.$Message.info("请输入流转信息");
          return false;
        }
      }
      switch (action) {
        case '回复': case '仅回复':
          this.doSendReplyInfo(newStr,'','',fromWhere);
          break
        case '抢单':
          //加入下划线用于证明是抢单
          this.grabbingOrder('-14','处理中_',newStr,fromWhere);
          break
        case '接单':
          this.onlyChangeState('-14','处理中',newStr,'',fromWhere);
          break
        case '取消暂停':
          let status = this.cancelPause.indexOf("_") ? this.cancelPause.split("_")[0] : '-14';
          let statusValue = this.cancelPause.indexOf("_") ? this.cancelPause.split("_")[1] : '处理中';
          this.onlyChangeState(status,statusValue,newStr,'',fromWhere);
          break
        case '暂停处理':
          this.onlyChangeState('-13','暂停',newStr,'',fromWhere);
          break
        case '处理完毕':
          let value = '已关闭';
          if('-12' == this.isOrderStateDone){
            value = '已完成';
          }
          this.onlyChangeState(this.isOrderStateDone,value,newStr,'',fromWhere);
          break
        case '接单并置为暂停':
          this.onlyChangeState('-13','暂停',newStr,'',fromWhere);
          break
        case '抢单并置为暂停':
          this.grabbingOrder('-13','暂停',newStr,fromWhere);
          break
        case '接单并处理完毕':
          this.onlyChangeState('-12','已完成',newStr,'',fromWhere);
          break
        case '抢单并处理完毕':
          this.grabbingOrder('-12','已完成',newStr,fromWhere);
          break
      }
      this.$refs.editDiv.innerHTML = '';
    },
    doDelete:function(){
      let value = this.radioForDelete;
      if(!value){
        this.$Modal.info({
          title: '提示',
          content: "请选择删除原因"
        })
        return false;
      }
      if('其他原因' == value){
        if(!this.contentForDelete){
          this.$Modal.info({
            title: '提示',
            content: "请填写具体删除原因"
          })
          return false;
        }
        value = '其他原因:'+ this.contentForDelete
      }
      let journalType = this.getFromWhereForParam('allWorkOrder');
      this.dialogForDelete = false;
      let param = {
        journalType:  journalType+'=>删除工单',
        menuId: this.orderDeleteFrom,
        ids: this.workOrderId,
        type:'0',
        deleteReason: value,
      };
      let that = this;
      that.$http.post("workOrder/doLogicDelete.json",param) .then(function (res) {
        let result = res.data.flag;
        if(result!="666"){
          that.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.$Message.info("工单已被删除");
        that.$emit("closeFlowEdit", that.pageCode);
      });
    },
    //删除工单
    deleteWorkOrder() {
      this.contentForDelete = '';
      this.radioForDelete = '';
      this.dialogForDelete = true;
    },
    revertWorkOrder(fromWhere){
      let param = {
        journalType: "工单管理=>回收站=>还原",
        menuId: "b_d-1",
        ids: this.workOrderId,
        type:'0',
      };
      let that=this;
      this.$Modal.confirm({
        title: '提示',
        content: "是否确定还原工单",
        onOk: () => {
          that.$http.post("workOrder/doRecovery.json",param) .then(function (res) {
            let result = res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$Message.info("还原成功");
            that.initWorkOrder(fromWhere);
          });
        }
      });
    },
    clickHandler: function (item,fromWhere) {
      let newHtml = "";
      if(this.$refs.editDiv){
        newHtml = this.$refs.editDiv.innerHTML;
      }else{
        newHtml = this.$refs.editDivHistory[0].innerHTML;
      }
      if(fromWhere){
        newHtml = this.$refs.editDivHistory[0].innerHTML;
      }
      let str = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
        .replace(/<\/?.+?\/?>/g, ''); //替换html标签
      let newStr = str.replace(/[ ]|[\r\n]/g, "");
      newStr = newStr.replace(/&nbsp;/g,"");
      if(!fromWhere){
        this.inputContent = this.$refs.editDiv.innerHTML + "<font style='display:none'>" + item.chars + "</font><img src='" + item.emoji + "'/>";
        this.$refs.editDiv.innerHTML = this.inputContent;
      }else{
        this.inputContent = this.$refs.editDivHistory[0].innerHTML + "<font style='display:none'>" + item.chars + "</font><img src='" + item.emoji + "'/>";
        this.$refs.editDivHistory[0].innerHTML = this.inputContent;
      }
      this.moveLast();
      document.getElementById("hiddenPop").click();
    },
    //将分组后的数据进行重列
    showFileList: function (fromWhere) {
      let formValidate = this.fileData;
      this.ruleValidate = {};
      this.showHideList = [];
      if (formValidate) {
        let list = [{required: true}];
        for (let j = 0; j < formValidate.length; j++) {
          this.showHideList.push('1');
          let fieldList = formValidate[j].fieldList;
          let allColumnInfo = [];
          if(fieldList){
            for (let i = 0; i < fieldList.length; i++) {
              let customIsSearch = fieldList[i].customIsSearch;
              let popCustomValue = fieldList[i].popCustomValue;
              let customIsSystem = fieldList[i].customIsSystem;
              let customColSource = fieldList[i].customColSource;
              let customColName = fieldList[i].customColName;
              let customName = fieldList[i].customName;
              let customType = fieldList[i].customType;
              let customIsMust = fieldList[i].customIsMust;
              if (customIsMust == '1') {
                this.ruleValidate[customColName] = list;
              }
              let customIsAlter = fieldList[i].customIsAlter;
              let customValue = fieldList[i].customType == 'cascade' ? [] : '';
              if (customColName == "orderChannel" && "add" == this.addOrEdit) {
                customIsAlter = '1';
                //渠道
                if('telephoneScreen' == fromWhere){
                  customValue = '-22';
                }
                if('onlineInfo' == fromWhere && this.onlineInfo){
                  let leftInfo = this.onlineInfo.leftInfo;
                  switch (leftInfo.channelType) {
                    case "-7":
                      customValue = '-23';
                      break
                    case "-8":
                      customValue = '-24';
                      break
                    case "-9":
                      customValue = '-25';
                      break
                  }
                }
              }
              if (customColName == "workOrderState") {
                this.orderStateItem.indexOne = j;
                this.orderStateItem.index = i;
              }
              if (customColName == "orderTheme" && this.orderTheme && this.orderTheme.popCustomValue) {
                popCustomValue = this.orderTheme.popCustomValue;
              }
              let newList = fieldList[i].list;
              if('telephoneScreen' == fromWhere && customColName == "customerName"){
                customValue = '';
              }
              if('telephoneScreen' == fromWhere && customColName == "customerPhone"){
                customValue = this.currentCallPhoneHide;
              }
              if ('telephoneScreen' == fromWhere && customColName == "customerName" && this.customerList && this.customerList.length>0) {
                customValue = this.customerList[0].customerName;
              }
              if (customColName == 'orderState') {
                this.dictOrderStateId = fieldList[i].id;
              }
              if (customColName == 'orderLabel' && newList && newList.length>0) {
                let item = fieldList[i].list.find(item => item.dictValue === '内部')
                //标签默认为内部
                if(item){
                  customValue = item.id;
                }
              }
              if (customColName == 'orderLevel' && newList && newList.length>0) {
                //优先级默认为最低的
                customValue = newList[0].id;
              }
              let columnParam = {
                type: customType,
                customColName: customColName,
                customValue: customValue,
                popCustomValue: popCustomValue ? popCustomValue:customValue,
                oldValue: customValue,
                checkName: "customValue",
                customIsMust: customIsMust,
                customName: customName,
                customIsSearch: customIsSearch,
                customIsAlter: customIsAlter,
                customIsSystem: customIsSystem,
                customColSource: customColSource,
                list: newList,
                id: fieldList[i].id,
              };
              if (customColName == "orderTheme") {
                this.orderTheme = columnParam;
              }
              if (customColName == "orderDescribe") {
                this.orderDescribe = columnParam;
              }
              allColumnInfo.push(columnParam);
            }
          }
          this.fileData[j].allColumnInfo = allColumnInfo;
        }
      }
      if ('add' == this.addOrEdit && 'allWorkOrder' == fromWhere) {
        let param = {
          fileData: this.fileData,
          contentList: this.contentList,
          flowList: this.flowList,
          uploadList: this.uploadList,
          pageUuId: this.pageUuId,
          orderTheme: this.orderTheme,
          orderDescribe: this.orderDescribe,
          isSecret: this.isSecret,
          showPreInput: this.showPreInput,
        };
        let newParam = JSON.parse(JSON.stringify(param));
        this.$store.commit('addWorkOrderData', newParam);
        let reserve = this.$store.getters.getWorkOrderData(this.pageUuId);
        this.fileData = reserve.fileData;
        this.contentList = reserve.contentList;
        this.flowList = reserve.flowList;
        this.uploadList = reserve.uploadList;
        this.pageUuId = reserve.pageUuId;
        this.orderTheme = reserve.orderTheme;
        this.orderDescribe = reserve.orderDescribe;
        this.isSecret = reserve.isSecret;
        this.showPreInput = reserve.showPreInput;
      }
      this.$forceUpdate();
    },
    //展示输入框中的输入提示
    showInput: function (action,fromWhere) {
      let newHtml = this.$refs.editDiv.innerHTML;
      let str = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
        .replace(/<\/?.+?\/?>/g, ''); //替换html标签
      let newStr = str.replace(/[ ]|[\r\n]/g, "");
      newStr = newStr.replace(/&nbsp;/g,"");

      if (!newStr) {
        if(newStr == this.showPreInput){
          return;
        }
      }
      if(newStr != this.showPreInput && 'allWorkOrder' == fromWhere) {
        this.showPreInput = this.$refs.editDiv.innerHTML;
        let param = {
          fileData: this.fileData,
          contentList: this.contentList,
          flowList: this.flowList,
          uploadList: this.uploadList,
          pageUuId: this.pageUuId,
          orderTheme: this.orderTheme,
          orderDescribe: this.orderDescribe,
          isSecret: this.isSecret,
          showPreInput: this.showPreInput,
        };
        let newParam = JSON.parse(JSON.stringify(param));
        this.$store.commit('addWorkOrderData', newParam);
      }
    },
    //历史工单进行修改信息私密公开
    changeSecretHistory: function (option, index,indexFlow,fromWhere) {
      let journalType = this.getFromWhereForParam(fromWhere);
      //改变私密信息
      let flag = "信息公开";
      if ('0' == this.historywoList[index].flowList[indexFlow].isSecret) {
        this.historywoList[index].flowList[indexFlow].isSecret = "1";
        flag = "信息私密";
      } else {
        this.historywoList[index].flowList[indexFlow].isSecret = "0";
      }
      let param = {
        journalType: journalType+"=>"+flag,
        menuId: "b_2-6",
        orderId: this.historywoList[index].staffId,
        id:this.historywoList[index].flowList[indexFlow].id,
      };
      this.changSecretPublic(param);
    },
    changSecretPublic:function(param){
      let that = this;
      this.$http.post("workOrder/doIsSecret.json", param).then(function (res) {
        let result = res.data.flag;
        if (result != "666") {
          that.$Modal.info({
            title: '提示',
            content: res.data.msg
          });
          return false;
        }
      });
    },
    changeSecret: function (option, index,fromWhere) {
      //改变私密信息
      let flag = "信息公开";
      if ('0' == this.flowList[index].isSecret) {
        this.flowList[index].isSecret = "1";
        flag = "信息私密";
      } else {
        this.flowList[index].isSecret = "0";
      }
      let journalType = this.getFromWhereForParam(fromWhere);
      let param = {
        journalType: journalType+"=>"+flag,
        menuId: "b_2-6",
        orderId: this.workOrderId,
        id:this.flowList[index].id,
      };
      this.changSecretPublic(param);
    },
    //获取全部客户弹屏选择
    getCustomerInfo: function () {
      this.showCustomerInfo = true;
    },
    //选中客户后的动作
    closeCustomerInfo: function (flag, selection,fromWhere) {
      this.showCustomerInfo = false;
      if (flag) {
        let indexOne = "";
        let index = "";
        let oldValue = this.customerId;
        this.customerId = selection.id;
        for (let j = 0; j < this.fileData.length; j++) {
          for (let i = 0; i < this.fileData[j].allColumnInfo.length; i++) {
            let customColName = this.fileData[j].allColumnInfo[i].customColName;
            if (customColName == "customerName") {
              this.fileData[j].allColumnInfo[i].popCustomValue = selection.customerName;
              indexOne = j;
              index = i;
            }
            if (customColName == "customerPhone") {
              this.fileData[j].allColumnInfo[i].popCustomValue = selection.telephoneOne;
              if ('1' == this.configInfo.phoneIsHide) {
                this.fileData[j].allColumnInfo[i].popCustomValue = selection.telephoneOneHide;
              }
              this.oldTelHide = selection.telephoneOneHide;
              this.oldTelFull = selection.telephoneOne;
            }
          }
        }
        if (oldValue != selection.id) {
          this.editWorkOrder(selection.id, this.fileData[indexOne].allColumnInfo[index], indexOne, index, selection.customerName,'','',fromWhere);
        }
      }
    },
    getFromWhereForParam:function(fromWhere){
      let newValue = '';
      if('telephoneScreen' == fromWhere){
        newValue = '电话弹屏';
      }else if('onlineInfo' == fromWhere){
        newValue = '在线客服';
      }else if('allWorkOrder' == fromWhere){
        let code = "";
        if(this.orderFromWhere){
          code = this.orderFromWhere.substring(0,3);
        }
        switch(code){
          case 'b_2':
            newValue = "工单管理=>所有工单";
            break;
          case 'b_3':
            newValue = "工单管理=>我的未完成工单";
            break;
          case 'b_4':
            newValue = "工单管理=>待我确认的工单";
            break;
          case 'b_5':
            newValue = "工单管理=>抄送给我的工单";
            break;
          case 'b_6':
            newValue = "工单管理=>我创建的工单";
            break;
          case 'b_7':
            newValue = "工单管理=>未分配的工单";
            break;
          case 'b_8':
            newValue = "工单管理=>已分配的工单";
            break;
          case 'b_9':
            newValue = "工单管理=>处理中的工单";
            break;
          case 'b_a':
            newValue = "工单管理=>暂停的工单";
            break;
          case 'b_b':
            newValue = "工单管理=>已完成的工单";
            break;
          case 'b_c':
            newValue = "工单管理=>已关闭的工单";
            break;
        }
      }
      if(!newValue){
        newValue = '跳转工单';
      }
      return newValue;
    },
    //以下为文件上传事件
    removeFile(file, fileList) {
      let url = file.url;
      let index = this.uploadList.findIndex(item => item.url === url);
      this.uploadList.splice(index, 1);
      let param = {
        addr: url,
      }
      this.$http.post('common/deleteFile.json', param);
    },
    handleBeforeUpload(file) {
      const check = this.uploadList.length < 5;
      if (!check) {
        this.$message.warning('最多只能上传 5 个附件。');
        return false;
      }
      this.fileType = file.type;
      return check;
    },
    uploadFail() {
      this.$Message.info("上传失败");
    },
    handleMaxSize(file) {
      this.$message.warning('文件 ' + file.name + ' 太大，不能超过 15M。');
    },
    onSuccess(res, file) {
      this.$Modal.info({
        title: '提示',
        content: res.msg
      });
      let param = {
        name: file.name,
        url: res.obj.absolutePath,
        type: this.fileType,
      };
      this.uploadList.push(param);
    },

    inputChange:function(e){
      let content = this.$refs.editDiv.innerHTML;
      this.replySourceData = JSON.parse(localStorage.getItem("ChatReplyWorkAndContent"));
      if(e.data){
        if(e.data === '#'){
          if(!this.replyFlag){
            this.replyFlag = true;
            this.replyData = this.replySourceData;
          }
        }
          let content = this.$refs.editDiv.innerHTML;
          let searchStr = content.substring(content.lastIndexOf('#'),content.length);
          this.replyData = this.replySourceData.filter(item => item.replyWord.indexOf(searchStr.replace('#','')) > -1 );
          // this.moveLast();
      }else{
        if(content.lastIndexOf('#')>-1){
          let searchStr = content.substring(content.lastIndexOf('#'),content.length);
          this.replyData = this.replySourceData.filter(item => item.replyWord.indexOf(searchStr.replace('#','')) > -1 );
        }else{
          this.replyFlag = false;
        }
        // this.moveLast();
      }
      if(this.replyData.length > 0 && content.lastIndexOf('#')>-1){ //没数据隐藏
        this.replyFlag = true;
      }
      if(this.replyData.length == 0){ //没数据隐藏
        this.replyFlag = false;
      }
      // 这里判断主要是因为 中文状态下输入这些字符，会有两个事件过来，导致前后两个相同的字符
      if((e.inputType == 'insertCompositionText')){
        let char = '~,！,@,#,￥,%,……,&,*,（,）,——,+,{,},|,《,》,？,·,-,=,【,】,、,；,‘,：,”,，,。,、,·';
        if(char.indexOf(e.data) > -1){
          this.textFlag = true;
          this.showInput('2','allWorkOrder');
          let that = this;
          setTimeout(function(){
            that.textFlag = false;
          },10);
        }
      }else{
        if(!this.textFlag){
          this.textFlag = false;
          this.showInput('2','allWorkOrder');
        }
      }
    },
    // 快捷回复点击
    onRowClick:function(data,index){
      let content = this.$refs.editDiv.innerHTML;
      this.$refs.editDiv.innerHTML = content.substring(0,content.lastIndexOf('#'))+data.replyContent;
      this.showInput('2','allWorkOrder');
      this.replyFlag = false;
    },
    // 移动光标放在最后
    moveLast:function(){
      let esrc = '';
      if(this.$refs.editDiv){
        esrc = this.$refs.editDiv;
      }else{
        esrc = this.$refs.editDivHistory[0];
      }
      setTimeout(function(){
        // var esrc = document.getElementById(obj);
        var range = document.createRange();
        range.selectNodeContents(esrc);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      },10);
    }
  }


};



// WEBPACK FOOTER //
// ./src/components/js/WorkOrderPublic.js